<template>
<div>
  <!-- Button to show input field -->
  <div v-if="showAddButton" class="pa-2" style="text-align: center;">
    <v-btn color="primary" outline @click="openCouponInput">
      {{ $vuetify.t('$vuetify.checkout.addCoupon') }}
    </v-btn>
  </div>

  <!-- Input field for entering coupon code -->
  <v-layout row wrap v-show="showCouponInput && !hasCouponCodeApplied" id="input">
    <v-flex xs8>
      <v-text-field ref="CouponInput"
        v-model="couponCode"
        :label="$vuetify.t('$vuetify.checkout.couponCode')"
        class="pr-2 py-0"
        clearable
      ></v-text-field>
    </v-flex>

    <v-flex xs4>
      <v-btn block outline class="ma-0" color="primary" @click="onApplyCoupon">
        {{ $vuetify.t('$vuetify.common.apply') }}
      </v-btn>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import get from 'lodash/get';

import { mapActions, mapGetters } from 'vuex';

export default {
  data: () => ({
    showCouponInput: false,
    couponCode: ''
  }),

  computed: {
    showAddButton() {
      return !this.showCouponInput && !this.hasCouponCodeApplied && !this.serverCoupons.length
    },

    serverCoupons() {
      return get(this.getServerCart, 'subOrderList[0].coupons', [])
    },

    hasCouponCodeApplied() {
      // Check local state, and server bill to ensure we have applied a valid coupon
      return !!this.getAllBillCoupons.length
    },

    ...mapGetters([
      'getServerCart',
      'getAllBillCoupons'
    ])
  },

  methods: {
    onApplyCoupon() {
      if (!this.couponCode)
        return

      this.setCouponCode({
        couponCode: this.couponCode
      })

      this.fetchShoppingCart()
      this.fetchBillView().catch(e => {
        this.showSnack({
          text: get(e, 'response.data.errorMsg', '') || 'Invalid coupon',
          color: 'error'
        })

        // If the api failed right after adding a coupon, we assume it's because
        // the coupon was invalid. It should have been valid until this point
        this.setCouponCode({
          couponCode: null
        })
      })
    },

    openCouponInput() {
      this.showCouponInput = true

      this.$nextTick(() => {
        this.$refs.CouponInput.focus()
      })
    },

    ...mapActions([
      'removeCoupon',
      'setCouponCode',
      'fetchShoppingCart',
      'fetchBillView',
      'showSnack'
    ])
  }
}
</script>

<style scoped>
  #input {
    padding: 30px 10px 0px
  }
</style>
